import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { textCss } from '../../../common/Css';
import IconToolTip from '../../../common/IconToolTip';
import { validateStringValue } from '../../../utils/common';
import { copyToClipboard } from '../../../actions/utils';
import Form from '../../../common/Form';
import { useForm } from 'react-hook-form';
import DatePicker from '../../../common/Form/DatePicker';
import { updatePoById } from '../../../actions/payments';
import { useSelector } from 'react-redux';


const formName = 'updatePo';

export const DetailsToShow = ({ poData }) => {
    const dispatch = useDispatch();
    const [originalDate, setOriginalDate] = useState(null);
    const [hasDateChanged, setHasDateChanged] = useState(false);
    const formButtonLoading = useSelector((state) => state.loading.formButtonLoading);

    const location = poData?.location;
    const assets = poData?.assets;

    const methods = useForm({ defaultValues: {}, mode: 'all' });
    const { submitRef, setValue, watch } = methods;

    const watchedDate = watch('po_date');

    const uodatePoData = (po_date) => {
        dispatch(updatePoById({ id: poData?.id, payload: { po_date }, formName: formName }));
        setOriginalDate(po_date);
        setHasDateChanged(false);
    }

    useEffect(() => {
        if (poData?.po_date) {
            const poDate = new Date(poData?.po_date);
            setValue('po_date', poDate);
            setOriginalDate(poDate);
        }
    }, [setValue, poData?.po_date]);

    useEffect(() => {
        if (originalDate && watchedDate) {
            const originalTime = originalDate.getTime();
            const currentTime = watchedDate.getTime();
            setHasDateChanged(originalTime !== currentTime);
        }
    }, [watchedDate, originalDate]);

    const hasAssetData = validateStringValue(assets?.[0]?.asset?.asset_number) || validateStringValue(assets?.[0]?.asset?.serial_number);
    const hasLocationData = validateStringValue(location?.external_id) || validateStringValue(location?.branch?.name);
    const hasAddressVendorData = validateStringValue(location?.address) || validateStringValue(poData?.vendor?.name);
    const hasAnyData = hasAssetData || hasLocationData || hasAddressVendorData;

    if (!hasAnyData) {
        return (
            <Form
                className='w-full'
                onSubmit={() => { }}
                methods={methods}
                submitRef={submitRef}
            >
                <div className='bg-white relative mb-4 border border-gray-200 rounded-lg overflow-hidden transition-all duration-300 shadow-md hover:shadow-xl'>
                    <div className='p-5'>
                        <div className='flex justify-end items-start gap-4'>
                            <div className='flex flex-col'>
                                <DatePicker name='po_date' label='Date' className='w-full focus:border-scogo15' />
                                {(hasDateChanged || formButtonLoading[formName]) ? (
                                    <button
                                        type='submit'
                                        className="mt-2 flex items-center gap-2 px-4 py-2 bg-blue-500 text-white rounded-lg hover:bg-blue-600 transition-all duration-200 text-md font-medium shadow-sm hover:shadow-md disabled:opacity-50 disabled:cursor-not-allowed"
                                        onClick={() => uodatePoData(methods.getValues('po_date'))}
                                        disabled={formButtonLoading[formName]}
                                    >
                                        {formButtonLoading[formName] ? (
                                            <>
                                                <span className='material-icons text-sm animate-spin'>
                                                    refresh
                                                </span>
                                                Updating...
                                            </>
                                        ) : (
                                            <>
                                                Update PO Date
                                                <span className="material-icons text-sm">save</span>
                                            </>
                                        )}
                                    </button>
                                ) : null}
                            </div>
                        </div>
                    </div>
                </div>
            </Form>
        );
    }

    return (
        <Form
            className='w-full'
            onSubmit={() => { }}
            methods={methods}
            submitRef={submitRef}
        >
            <div className='bg-white relative mb-4 border border-gray-200 rounded-lg overflow-hidden transition-all duration-300 shadow-md hover:shadow-xl'>
                <div className='p-5'>
                    <div className='grid grid-cols-1 md:grid-cols-4 gap-4'>
                        {validateStringValue(assets?.[0]?.asset?.asset_number) && (
                            <DetailItem
                                icon="inventory_2"
                                label="Asset Number"
                                value={validateStringValue(assets?.[0]?.asset?.asset_number)}
                            />
                        )}
                        {validateStringValue(assets?.[0]?.asset?.serial_number) && (
                            <DetailItem
                                icon="tag"
                                label="Serial Number"
                                value={validateStringValue(assets?.[0]?.asset?.serial_number)}
                            />
                        )}

                        {validateStringValue(location?.external_id) && (
                            <DetailItem
                                icon="location_on"
                                label="External Site ID"
                                value={validateStringValue(location?.external_id)}
                            />
                        )}

                        {validateStringValue(location?.branch?.name) && (
                            <DetailItem
                                icon="business"
                                label="Branch Name"
                                value={validateStringValue(location?.branch?.name)}
                            />
                        )}

                        {validateStringValue(location?.address) && (
                            <div className="flex items-start group">
                                <span className="material-icons text-scogobgsky mr-3 mt-0.5 text-xl">home</span>
                                <div className="flex-grow">
                                    <h3 className="text-gray-500 text-sm font-medium mb-1">Address</h3>
                                    <IconToolTip title={`Address: ${validateStringValue(location?.address)}`}>
                                        <p className="text-scogoprimary font-medium line-clamp-2 group-hover:text-scogoorange transition-colors duration-200">
                                            {validateStringValue(location?.address)}
                                        </p>
                                    </IconToolTip>
                                </div>
                            </div>
                        )}
                        {validateStringValue(poData?.vendor?.name) && (
                            <DetailItem
                                icon="person"
                                label="Vendor"
                                value={validateStringValue(poData?.vendor?.name)}
                            />
                        )}
                        <div className='flex items-center '>
                            <DatePicker name='po_date' label='Date' className='max-w-max focus:border-scogo15' />
                            {(hasDateChanged || formButtonLoading[formName]) ? (
                                <button
                                    type='submit'
                                    className="mt-6 max-w-maxmt-2 text-sm flex items-center gap-2 px-3 py-1 bg-blue-500 text-white rounded-lg hover:bg-blue-600 transition-all duration-200 text-md font-medium shadow-sm hover:shadow-md disabled:opacity-50 disabled:cursor-not-allowed"
                                    onClick={() => uodatePoData(methods.getValues('po_date'))}
                                    disabled={formButtonLoading[formName]}
                                >
                                    {formButtonLoading[formName] ? (
                                        <>
                                            <span className='material-icons text-sm animate-spin'>
                                                refresh
                                            </span>
                                            Updating...
                                        </>
                                    ) : (
                                        <>
                                            Update
                                            <span className="material-icons text-sm">save</span>
                                        </>
                                    )}
                                </button>
                            ) : null}
                        </div>
                    </div>
                </div>
            </div>
        </Form>
    );
};

const DetailItem = ({ icon, label, value }) => (
    <div className="flex items-start group">
        <span className="material-icons text-scogobgsky mr-3 mt-0.5 text-xl">{icon}</span>
        <div>
            <h3 className="text-gray-500 text-sm font-medium mb-1">{label}</h3>
            <IconToolTip title={`${label}: ${value}`}>
                <p className="text-scogoprimary font-medium line-clamp-2 group-hover:text-scogoorange transition-colors duration-200">
                    {value}
                </p>
            </IconToolTip>
        </div>
    </div>
);